import { useEffect ,useState} from "react";
import "../../cssfiles/homepage.css";
import { useSelector } from "react-redux";
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import LK_TimerClock from "../../images/LK_TimerClock";
import dayjs from 'dayjs';

// import { TimeRangePicker } from '@mui/x-date-pickers-pro/TimeRangePicker';
// import { MultiInputTimeRangeField } from '@mui/x-date-pickers-pro/MultiInputTimeRangeField';LK_TimerClock

export default function CustomTimePicker({id, width , disabled, widthIcon, heightIcon ,fontSize, ampm, onChange , defaultValue, views, timeSteps}) {
  const theme = useSelector((state) => state.themedata.theme);
  const [value, setValue] = useState(defaultValue?dayjs(defaultValue):dayjs('2022-04-17T00:00:00'));
  // const [placeholder,setPlaceholder] = useState("")

  // useEffect(() => {
  //   // This effect can be used for any side effects related to the time picker
  //   // For example, logging or fetching data when the component mounts
  //   let placeholderText = "";
  //   if (ampm  && ampm === true) {
  //   }    2025-09-24T00:10:00
  //   setPlaceholder(ampm ? 'HH:MM' : 'HH:MM AA');
  // }, [ampm,]);

  useEffect(() => {
      if(defaultValue!==null && defaultValue!==undefined && defaultValue!==""){
              setValue(dayjs(defaultValue));
      }
    }, [defaultValue]);
  
  function handleOnChange(newValue,e,x) {
    // Handle the change event here //Wed Sep 24 2025 00:10:00 GMT+0530 (India Standard Time)
    setValue(newValue);
    //const formatted = dayjs(newValue.$d).format("YYYY-MM-DDTHH:mm:ss");
    const formatted = newValue
    console.log("7777",newValue,e,x, id )
    onChange(formatted, id , e);
  }

  return (
    <>
      <LocalizationProvider id= { id ? id : null} dateAdapter={AdapterDayjs}>
        <TimePicker  
        
            ampm={ampm? ampm : true}
            variant="standard"
            sx ={{
              width: width ? width : "auto",
              //height: height ? height : "auto",
            }}
            views={views?views:['hours', 'minutes', 'seconds']}
            timeSteps={timeSteps?timeSteps:{hours: 1, minutes: 5, seconds: 5}}
            value={value}
            slotProps={{ textField: { variant: 'standard', id: id ? id : null ,/*placeholder: placeholder*/
              sx:{
                    "& .MuiInputAdornment-root": {
                      //height: "px", // Set your desired height here
                      minHeight: "24px",
                      minWidth:"20px",
                      display: "flex",
                      alignItems: "center",
                    },
                    "& .MuiIconButton-root": {
                      padding: "0px 0px 4px 0px",
                    },
                    width: width ? width : "auto",
                    "& .MuiInputBase-input:focus": {
                      color: "#008CD7",
                    },
                    "& .MuiInputBase-root": {
                      fontFamily: "Roboto",
                      fontSize: fontSize ? fontSize : "16px",
                      fontWeight: "700",
                      color: theme === "light" ? "#3C3C3C" : "#C1C1C1",
                      //color: theme === 'light' ? '#3C3C3C' : '#FFFFFF'
                    },
                    "& .MuiInputBase-input.Mui-disabled": {
                      WebkitTextFillColor: theme === "light" ? "#C1C1C1" : "#3C3C3C",
                      //WebkitBorderFillColor: theme === 'light' ? '#C1C1C1' : '#3C3C3C',
                    },
                    // '& .MuiInput-underline.Mui-disabled':{
                    //     color: theme === 'light' ? '#C1C1C1' : '#pink',
                    // },
                    "& .MuiInput-root .MuiInputBase-input": {
                      padding: 0,
                    },
                    "& .MuiInputBase-root::before": {
                      //borderBottom: `1px solid ${theme === 'light' ? '#3C3C3C' : '#FFFFFF'}`
                      borderBottom: `1px solid ${
                        (disabled != null ? disabled : false) == true
                          ? theme === "light"
                            ? "#C1C1C1"
                            : "#3C3C3C"
                          : "var(--GreyVariation_2)"
                      }`,
                    },
                    "& ::-webkit-input-placeholder": {
                      color: theme === "light" ? "#3C3C3C" : "#C1C1C1",
                    },
                    "& .MuiInputBase-root::after": {
                      borderBottom: "2px solid #008CD7",
                    },
                    "& .Mui-error": {
                      color: "var(--RedBaseColor)",
                    },
                  }
              } 
            }} 
            onChange={handleOnChange}
            slots={{
              openPickerIcon:() => <LK_TimerClock color={disabled===true?theme === 'light' ? '#C1C1C1' : '#3C3C3C':'#008CD7'} width={widthIcon ? widthIcon : "20px"} height={heightIcon ? heightIcon :"20px"}/>
            }}
        />
      </LocalizationProvider>
    </>     
  );
}
